"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.STRING_CONSTS = exports.REGEXP_KEYWORDS = exports.LOCAL_STORAGE_KEY = void 0;
const STRING_CONSTS = exports.STRING_CONSTS = Object.freeze({
  HYPHEN_ZENKAKU: '－',
  EMPTY: '',
  SLASH_ZENKAKU: '／',
  SLASH_HANKAKU: '/',
  ROOT_PATH: '/',
  KAKKO_CIR_START: '（',
  KAKKO_CIR_END: '）',
  TOUTEN_ZENKAKU: '、',
  HALF_SPACE: ' ',
  FULL_SPACE: '　',
  KAKKO_SUMI_START: '【',
  KAKKO_SUMI_END: '】',
  KAKKO_CHU_START_HANKAKU: '{',
  KAKKO_CHU_END_HANKAKU: '}',
  KAKKO_DAI_START_HANKAKU: '[',
  KAKKO_DAI_END_HANKAKU: ']',
  KAKKO_SHO_START_HANKAKU: '(',
  KAKKO_SHO_END_HANKAKU: ')',
  ASTERISK: '*',
  ASTERISK_ZENKAKU: '＊',
  PLUS: '+',
  COMMA: '.',
  QUESTION: '?',
  HAT: '^',
  DOLLAR: '$',
  PIPE: '|',
  COLON: ':',
  COLON_ZENKAKU: '：',
  ELLIPSIS: '…',
  FULL_DOT: '・',
  CIRCLE: '〇',
  TIMES: '×'
});
const REGEXP_KEYWORDS = exports.REGEXP_KEYWORDS = Object.freeze([STRING_CONSTS.ASTERISK, STRING_CONSTS.PLUS, STRING_CONSTS.COMMA, STRING_CONSTS.QUESTION, STRING_CONSTS.KAKKO_CHU_START_HANKAKU, STRING_CONSTS.KAKKO_CHU_END_HANKAKU, STRING_CONSTS.KAKKO_SHO_START_HANKAKU, STRING_CONSTS.KAKKO_SHO_END_HANKAKU, STRING_CONSTS.KAKKO_DAI_START_HANKAKU, STRING_CONSTS.KAKKO_DAI_END_HANKAKU, STRING_CONSTS.HAT, STRING_CONSTS.DOLLAR, STRING_CONSTS.PIPE, STRING_CONSTS.COLON]);
const LOCAL_STORAGE_KEY = exports.LOCAL_STORAGE_KEY = Object.freeze({
  FILTER_BY_DATE: 'FilterByDate'
});